import classNames from 'classnames';
import React, { memo } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Layout } from '../../../../../../../components';
import CattegoryFilter from '../CattegoryFilter/CattegoryFilter';
import SegmentFilter from '../SegmentFilter/SegmentFilter';
import StoreFilter from '../StoreFilter/StoreFilter';
import styles from './RegisterLimitPageFilters.module.scss';

const RegisterLimitPageFilters = memo(() => {
  return (
    <Layout.Section padded className={classNames(styles.wrapper)}>
      <div className={styles.header}>
        <h4>Defina onde aplicar o limite</h4>
        <p>O limite será aplicado a todas as categorias e/ou produtos selecionados</p>
      </div>
      <ul className={styles.filters}>
        <CattegoryFilter />
        <StoreFilter />
        <SegmentFilter />
      </ul>
    </Layout.Section>
  );
});

RegisterLimitPageFilters.displayName = 'RegisterLimitPageFilters';

export default withRouter(connect()(RegisterLimitPageFilters));
